import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Careerlist = () => {
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchCareers();
  }, []);

  const fetchCareers = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/careers/user/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCareers(data);
      } else {
        setMessage("Failed to fetch careers.");
      }
    } catch (error) {
      console.error("Error fetching careers:", error);
      setMessage("An error occurred while fetching careers.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this career posting?")
    ) {
      try {
        const token = localStorage.getItem("access");
        const response = await fetch(
          `https://ambatturindustrialestate.com/api/api/careers/${id}/`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          setMessage("Career posting deleted successfully!");
          // Remove the deleted career from the list
          setCareers(careers.filter((career) => career.id !== id));
        } else {
          setMessage("Failed to delete career posting.");
        }
      } catch (error) {
        console.error("Error deleting career:", error);
        setMessage("An error occurred while deleting the career posting.");
      }
    }
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>My Career Postings</h2>
        <div>
          <Link to="/careers/applications" className="btn btn-info me-2">
            <i className="bi bi-people-fill me-2"></i>View Applications
          </Link>
          <Link to="/careers/create" className="btn btn-primary">
            <i className="bi bi-plus-circle me-2"></i>Add New Career
          </Link>
        </div>
      </div>

      {message && (
        <div
          className={`alert ${
            message.includes("successfully") ? "alert-success" : "alert-danger"
          } alert-dismissible fade show`}
        >
          {message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          ></button>
        </div>
      )}

      {careers.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <h5 className="card-title">No career postings found</h5>
            <p className="card-text">
              You haven't created any career postings yet.
            </p>
            <Link to="/careers/create" className="btn btn-primary">
              Create Your First Career Posting
            </Link>
          </div>
        </div>
      ) : (
        <div className="row">
          {careers.map((career) => (
            <div key={career.id} className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0">{career.role}</h5>
                </div>
                <div className="card-body">
                  <p className="card-text">
                    <strong>Vacancies:</strong> {career.vacancy}
                  </p>
                  <p className="card-text">
                    {career.job_description.length > 150
                      ? `${career.job_description.substring(0, 150)}...`
                      : career.job_description}
                  </p>
                </div>
                <div className="card-footer bg-transparent">
                  <div className="d-flex justify-content-between">
                    <Link
                      to={`/careers/edit/${career.id}`}
                      className="btn btn-outline-primary btn-sm"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(career.id)}
                      className="btn btn-outline-danger btn-sm"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Careerlist;
